// api 黑名单，配置在这的地址 不会显示loading

// const baseUrl = process.env.VUE_APP_SYSTEM
const api = [
  '/labelType/getLabelTypeList', // 获取标签类型接口
  '/organization/getKindergartenById', // 根据归属id查询查询片区或幼儿园，type(2片区;3园所;)
  '/admissionStatistics/getEmployeeConversionRateField', // 转化统计-查询员工转化显示字段
  '/common/getDictoryInfoByCode', // 字典
  // '/news/getEmployeeOrParentTree', // 根据工作域查 员工 或 家长
  '/homePage/getWorkAreasScaleDept', // 查询部门组织架构
  '/homePage/getAllWorkAreasDept', // 查询部门组织架构
  '/approvalRule/getApprovalUserList', // 根据部门组织架构查询审批人和抄送人
  '/approvalRule/getSystemOrganizationTreeList', // 组织架构树结构
  '/approvalRule/getPositionTreeList', // 职位树结构
  '/approvalRule/getApprovalGroupTreeList', // 审批组树结构
  '/shroffAccount/getKindergartenList', // 查询集团、园所下拉框列表
  '/homePage/getWorkAreasScaleRes', // 当前工作域下的组织机构
  '/organization/getDeptById', // 根据归属id查询  type：(3园所;4部门)
  '/dep/deptTreeData', // 部门树结构
  '/organization/getAllOrganization' // 组织机构查询(type:1所有，4部门)
]

export default {
  api
}



// WEBPACK FOOTER //
// ./src/utils/loadingApi.js